<script lang="ts">
  let { current = 0, max = 100, size = "44px", strokeWidth = 3, color = "#00B751" } = $props();

  // Calculate percentage
  const percentage = $derived(Math.min(Math.round((current / max) * 100), 100));

  // Format number with K/M suffix
  function formatNumber(num: number): string {
    if (num >= 1000000) {
      return (num < 10000000 ? (num / 1000000).toFixed(1) : Math.round(num / 1000000)) + "M";
    } else if (num >= 1000) {
      return (num < 100000 ? (num / 1000).toFixed(1) : Math.round(num / 1000)) + "K";
    }
    return Math.round(num).toString();
  }

  // Calculate circle properties
  const radius = $derived(35 - strokeWidth / 2);
  const circumference = $derived(2 * Math.PI * radius);
  const strokeDashoffset = $derived(circumference - (percentage / 100) * circumference);

  // Calculate center point
  const center = $derived(50);
</script>

<div class="inline-block transition-transform" style:width={size} style:height={size}>
  <svg viewBox="0 0 100 100" class="h-full w-full transform transition-all duration-300 ease-in-out">
    <!-- Background circle -->
    <circle
      cx={center}
      cy={center}
      r={radius}
      fill="none"
      stroke="currentColor"
      stroke-width={strokeWidth}
      class="opacity-20"
    />

    <!-- Progress circle -->
    <circle
      cx={center}
      cy={center}
      r={radius}
      fill="none"
      stroke={color}
      stroke-width={strokeWidth}
      stroke-linecap="round"
      stroke-dasharray={circumference}
      stroke-dashoffset={strokeDashoffset}
      transform="rotate(-90 50 50)"
      class="transition-all duration-300 ease-in-out"
    />

    <!-- Text in the middle -->
    <text
      x={center}
      y={center}
      text-anchor="middle"
      dominant-baseline="middle"
      font-size="20"
      fill={color}
      class="font-sans font-bold"
    >
      {formatNumber(current)}
    </text>
  </svg>
</div>
